import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import userContext from "./context";
import BankBg from "./bank2.jpg";

export default function Create() {
  const [show, setShow] = useState(true);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { users, setUsers } = useContext(userContext);
  const navigate = useNavigate();

  function handleCreate() {
    if (!name) {
      alert("Name is required");
      return;
    }
    if (!email) {
      alert("Email is required");
      return;
    }
    if (password.length < 8) {
      alert("Password must be at least 8 characters");
      return;
    }

    setUsers([...users, { name, email, password, balance: 0 }]);
    setShow(false);
  }

  function clearForm() {
    setName("");
    setEmail("");
    setPassword("");
    setShow(true);
  }

  return (
    <div
      style={{
        backgroundImage: `url(${BankBg})`,
        backgroundSize: "cover",
        minHeight: "100vh",
        paddingTop: "50px",
      }}
    >
      <div className="container">
        <div
          className="card mx-auto shadow-lg"
          style={{
            maxWidth: "25rem",
            borderRadius: "15px",
            border: "none",
            backgroundColor: "rgba(255, 255, 255, 0.92)",
          }}
        >
          <div
            className="card-header text-center text-white"
            style={{
              backgroundColor: "#04549B",
              borderRadius: "15px 15px 0 0",
              padding: "20px",
            }}
          >
            <h3 className="mb-0">Join Royal Bank</h3>
            <small>Create your digital account today</small>
          </div>

          <div className="card-body p-4">
            {show ? (
              <>
                <div className="mb-3">
                  <label className="form-label fw-bold">Full Name</label>
                  {/* Fixed (e) below to solve ESLint error */}
                  <input
                    className="form-control form-control-lg"
                    placeholder="Enter your name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label fw-bold">Email Address</label>
                  <input
                    type="email"
                    className="form-control form-control-lg"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="mb-4">
                  <label className="form-label fw-bold">Password</label>
                  <input
                    type="password"
                    className="form-control form-control-lg"
                    placeholder="Enter your password (Min 8 characters)"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <button
                  disabled={!name && !email && !password}
                  className="btn btn-primary btn-lg w-100 shadow-sm"
                  style={{ backgroundColor: "#04549B", border: "none" }}
                  onClick={handleCreate}
                >
                  Create Account
                </button>
              </>
            ) : (
              <div className="text-center py-4">
                <div className="mb-3 text-success">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="64"
                    height="64"
                    fill="currentColor"
                    className="bi bi-check-circle-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                  </svg>
                </div>
                <h4 className="mb-3">Success!</h4>
                <button
                  className="btn btn-primary w-100 mt-2 mb-2"
                  onClick={() => navigate("/deposit")}
                >
                  Go to Deposit
                </button>
                <button
                  className="btn btn-outline-primary w-100 mb-2"
                  onClick={clearForm}
                >
                  Add Another Account
                </button>
                <button
                  className="btn btn-sm btn-link text-secondary"
                  onClick={() => navigate("/home")}
                >
                  Back Home
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
